module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_iterators.js
// module id = 70
// module chunks = 0